import {
  LOGIN_SUCCESS,
  LOGIN_FAIL,
  LOGOUT_SUCCESS,
  GET_NOTIFICATIONS,
  ADD_NOTIFICATIONS,
  NO_MORE_NOTIFICATIONS,
  CHANGE_ITEM_STATUS,
  CHANGE_SHOP_STATUS,
  NEW_NOTIFICATION,
  UPLOAD_DP,
  SELLER_IS_BLOCKED,
  CLEAR_AUTH_MSG
} from "./Types";

import { returnErrors } from "./errorActions";
import registerForPushNotifications from "../constants/registerForPushNotifications";
import url from "../constants/URL.js";

export const login = (data) => (dispatch) => {
  fetch(`${url}/seller/login`, {
    method: "POST",
    headers: {
      Accept: "application/json",
      "Content-Type": "application/json",
    },
    body: JSON.stringify(data),
  })
    .then((res) => res.json())
    .then((data) => {
      if (data.msg === "Login Successfully" && data.data.status === "blocked") {
        dispatch({
          type: SELLER_IS_BLOCKED,
        });
      } else {
        if (data.msg === "Login Successfully") {
          registerForPushNotifications(data.data._id);
          dispatch({
            type: LOGIN_SUCCESS,
            payload: data,
          });
        } else {
          dispatch(returnErrors(data.error));
          dispatch({
            type: LOGIN_FAIL,
          });
        }
      }
    });
};

export const changeShopStatus = (sellerID, status) => async (dispatch) => {
  const token = await JSON.parse(localStorage.getItem("persist:auth")).token;
  fetch(`${url}/change/shop/status/${sellerID}`, {
    method: "PUT",
    headers: {
      Accept: "application/json",
      "Content-Type": "application/json",
      Authorization: `Bearer ${token}`,
    },
    body: JSON.stringify({ open: status }),
  })
    .then((res) => res.json())
    .then(() => {
      dispatch({
        type: CHANGE_SHOP_STATUS,
        payload: status,
      });
    });
};

export const changeItemStatus = (itemID, status) => async (dispatch) => {
  const token = await JSON.parse(localStorage.getItem("persist:auth")).token;
  fetch(`${url}/change/item/status/${itemID}`, {
    method: "PUT",
    headers: {
      // "x-auth-token": user.token,
      Accept: "application/json",
      "Content-Type": "application/json",
      Authorization: `Bearer ${token}`,
    },
    body: JSON.stringify({ available: status }),
  })
    .then((res) => res.json())
    .then(() => {
      dispatch({
        type: CHANGE_ITEM_STATUS,
        payload: status,
      });
    });
};

// Logout User
export const logout = () => {
  return {
    type: LOGOUT_SUCCESS,
  };
};

export const forgotPassword = (contactNumber, password) => (dispatch) => {
  fetch(`${url}/${contactNumber}/forgot/password`, {
    method: "PUT",
    headers: {
      Accept: "application/json",
      "Content-Type": "application/json",
    },
    body: JSON.stringify({ password }),
  })
    .then((res) => res.json())
    .then((response) => {
      if (response.msg === "Password Changes Successfully") {
        dispatch({
          type: LOGIN_SUCCESS,
          payload: response,
        });
      }
    })
    .catch((err) => {
      dispatch(returnErrors({ error: { error: "Network Error" } }));
    });
};

export const getNotifications = (sellerId, skip) => async (dispatch) => {
  const token = JSON.parse(localStorage.getItem("persist:auth")).token;
  fetch(`${url}/notifications/${sellerId}/?skip=${skip}`, {
    method: "GET",
    headers: {
      Accept: "application/json",
      "Content-Type": "application/json",
      Authorization: `Bearer ${token}`,
    },
  })
    .then((res) => {
      res.json().then((response) => {
        if (Array.isArray(response)) {
          if (Number(skip) === 0) {
            dispatch({
              type: GET_NOTIFICATIONS,
              payload: response,
            });
          } else {
            if (response.length === 0) {
              dispatch({
                type: NO_MORE_NOTIFICATIONS,
              });
            } else {
              dispatch({
                type: ADD_NOTIFICATIONS,
                payload: response,
              });
            }
          }
        } else {
          dispatch(
            returnErrors({ error: { error: "Notifications fetching fails" } })
          );
        }
      });
    })
    .catch(() => {
      dispatch(returnErrors({ error: { error: "Network error" } }));
    });
};

export const newNotification = (newNotification) => async (dispatch) => {
  dispatch({
    type: NEW_NOTIFICATION,
    payload: newNotification,
  });
};

export const uploadDp = (id, imageFile) => (dispatch) => {
  fetch(`${url}/shop/dp/upload/${id}`, {
    headers: {
      Accept: "application/json",
    },
    method: "POST",
    body: imageFile,
  }).then((resp) => {
    resp.json((imageURL) => {
      dispatch({
        type: UPLOAD_DP,
        payload: imageURL,
      });
    });
  });
};


export const clearAuthMsg = () => async (dispatch) => {
  dispatch({
    type: CLEAR_AUTH_MSG,
  });
};